module.exports = __webpack_public_path__ + "static/img/icon_swiper_button_next.6b039d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_swiper_button_next.svg
// module id = sdvk
// module chunks = 10